export enum TrackingFeatureType {
  Migrations = 'Migrations',
  // to be extended
}
